// services/api.js
import axios from 'axios';

const endPointProduction="https://api.thezaar.pk/api"
const endPointDev="http://localhost:4000/api"

// Use environment variable if set, otherwise fallback to appropriate endpoint
const baseURL = process.env.REACT_APP_API_BASE_URL || 
  (process.env.NODE_ENV === 'production' ? endPointProduction : endPointDev);

export const API = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

function getCookie(name) {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`));
  if (!match) return undefined;
  const rawValue = match.split('=').slice(1).join('=');
  try {
    return decodeURIComponent(rawValue) || undefined;
  } catch {
    // Return raw cookie value if decoding fails
    return rawValue || undefined;
  }
}

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const fbp = getCookie('_fbp');
  const fbc = getCookie('_fbc');
  if (fbp) config.headers['x-fbp'] = fbp;
  if (fbc) config.headers['x-fbc'] = fbc;
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

